import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSettings, saveSetting } from '../../services/api/settingsService';

export const loadSettings = createAsyncThunk('platformSettings/load', async () => fetchSettings());

export const updateSetting = createAsyncThunk(
  'platformSettings/update',
  async ({ key, value }) => saveSetting(key, value)
);

const settingsSlice = createSlice({
  name: 'platformSettings',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSettings.pending, (state) => { state.status = 'loading'; })
      .addCase(loadSettings.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadSettings.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        const item = state.items.find((s) => s.key === action.payload.key);
        if (item) item.value = action.payload.value;
      });
  }
});

export default settingsSlice.reducer;
